<div class="tw-rounded-xl tw-bg-dt-surface-card tw-overflow-hidden">
  <!-- Header -->
  <div
    class="tw-flex tw-items-start tw-p-7 tw-space-x-4 sm:tw-flex-col sm:tw-space-x-0 sm:tw-space-y-3"
  >
    <span
      class="transaction-form-label tw-text-blue-600 !tw-border !tw-border-solid !tw-border-blue-200/50 tw-bg-blue-50 dark:tw-text-color-status-info-text dark:!tw-border-color-status-info-border dark:tw-bg-color-status-info-bg !tw-font-bold tw-uppercase tw-tracking-wide"
      >Align.</span
    >
    <div class="tw-flex tw-flex-col tw-space-y-1 tw-ml-2 sm:tw-ml-0 tw-flex-grow">
      <span class="tw-text-2xl sm:tw-text-xl tw-text-dt-text-headings tw-font-semibold">{{
        "balanceAlignment" | i18n
      }}</span>
      <span class="tw-text-base sm:tw-text-sm tw-text-dt-text-secondary tw-leading-5">{{
        "balanceAlignmentMsg" | i18n
      }}</span>
    </div>
  </div>

  <hr class="border-dashed" />

  <!-- Body -->
  <div class="tw-flex tw-flex-col tw-px-6 tw-py-5 sm:tw-px-4 sm:tw-py-4">
    <!-- Account label -->
    <p
      class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-secondary tw-mb-4"
    >
      {{ "forAccount" | i18n }} {{ data().source }}
    </p>

    <!-- Stated Balance card -->
    <div
      class="tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-px-5 tw-py-4 tw-bg-dt-surface-card tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
    >
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-secondary"
          >{{ "statedBalance" | i18n }}</span
        >
        <span class="tw-text-sm tw-text-dt-text-tertiary">{{ "enteredImported" | i18n }}</span>
      </div>
      <div class="tw-flex tw-items-center tw-gap-3">
        <div class="tw-flex tw-flex-col tw-items-end">
          <span
            class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-tertiary"
            >{{ data().symbol }}</span
          >
          <span class="font-number tw-text-xl tw-font-semibold tw-text-dt-text-headings">{{
            data().statedBal | number: "1.0-2"
          }}</span>
        </div>
        <button
          class="tw-flex tw-items-center tw-justify-center tw-cursor-pointer tw-bg-dt-surface-card tw-rounded-xl tw-p-1 tw-aspect-square tw-shadow-neuomorphic-raised tw-border-0"
          [attr.aria-label]="'edit' | i18n"
          (click)="openEditBalance()"
        >
          <icon
            [size]="6"
            [name]="'edit'"
            [currentColor]="'primary'"
            class="tw-bg-dt-surface-card tw-border tw-border-primary tw-w-10 tw-h-10 tw-rounded-lg tw-shadow-icon-edit tw-aspect-square"
          ></icon>
        </button>
      </div>
    </div>

    <!-- Minus operator bubble -->
    <div class="tw-flex tw-justify-center tw-my-2">
      <div
        class="operator-bubble tw-bg-dt-surface-card tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
        aria-hidden="true"
      >
        &minus;
      </div>
    </div>

    <!-- Running Balance card -->
    <div
      class="tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-px-5 tw-py-4 tw-bg-dt-surface-card tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
    >
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-secondary"
          >{{ "runningBalance" | i18n }}</span
        >
        <span class="tw-text-sm tw-text-dt-text-tertiary">{{ "fromYourTransactions" | i18n }}</span>
      </div>
      <div class="tw-flex tw-flex-col tw-items-end">
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-tertiary"
          >{{ data().symbol }}</span
        >
        <span class="font-number tw-text-xl tw-font-semibold tw-text-dt-text-headings">{{
          runningBal() | number: "1.0-2"
        }}</span>
      </div>
    </div>

    <!-- Equals operator bubble -->
    <div class="tw-flex tw-justify-center tw-my-2">
      <div
        class="operator-bubble tw-bg-dt-surface-card tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
        aria-hidden="true"
      >
        =
      </div>
    </div>

    <!-- Alignment Entry card -->
    <div
      class="tw-flex tw-items-center tw-justify-between tw-rounded-xl tw-px-5 tw-py-4 tw-bg-dt-surface-card tw-shadow-card-elevated dark:!tw-shadow-elevation-card"
    >
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-secondary"
          >{{ "alignmentEntry" | i18n }}</span
        >
        <span class="tw-text-sm tw-text-dt-text-tertiary">{{
          "autoGeneratedTransaction" | i18n
        }}</span>
      </div>
      <div class="tw-flex tw-flex-col tw-items-end">
        <span
          class="tw-text-[11px] tw-font-bold tw-uppercase tw-tracking-[0.09em] tw-text-dt-text-tertiary"
          >{{ data().symbol }}</span
        >
        <span
          class="font-number tw-text-xl tw-font-semibold"
          [ngClass]="{
            'tw-text-dt-text-in-primary': data().alignTransac > 0.01,
            'tw-text-dt-text-secondary':
              data().alignTransac >= -0.01 && data().alignTransac <= 0.01,
            'tw-text-dt-text-out-primary': data().alignTransac < -0.01,
          }"
          >{{ data().alignTransac | number: "1.0-2" }}</span
        >
      </div>
    </div>
  </div>
</div>
